export default __webpack_public_path__ + "static/media/cell-culture-versatility-solution.acf90e61.png";